import { render } from "./UpdateTime.vue?vue&type=template&id=27b8336a&ts=true"
import script from "./UpdateTime.vue?vue&type=script&lang=ts"
export * from "./UpdateTime.vue?vue&type=script&lang=ts"

import "./UpdateTime.vue?vue&type=style&index=0&id=27b8336a&lang=css"

import exportComponent from "/home/runner/work/hotaru_theme/hotaru_theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__